// extracted by mini-css-extract-plugin
export default {"whatsappButton":"WhatsappButton_whatsappButton__jY9od","disabledButton":"WhatsappButton_disabledButton__aDrF5","iconContainer":"WhatsappButton_iconContainer__d57qT"};